import { SharedFuncReference } from "@/utils/shared-func-reference";
import { FrontendFunc } from "./frontend-func";

export class AutoSaleRowSetting {
	ID:number = 0;
	Description:string = "Nieuwe instelling";
	Funcs:FrontendFunc[] = [];
	Amount1:string = "";
	Amount2:string = "";
	ProductSku:string = "";
	ProductDescription:string = "";
	UnitPrice:string = "";
	LeeggoedTax:string = "";
	EcoboniTax:string = "";
	AccijnzenTax:string = "";
	VatID:string = "";
	ShouldRunScript:string = "";
	VatRegimeFilter:number[] = [];
	SaleTypeFilter:number[] = [];
	SharedFuncList:SharedFuncReference[] = [];

	constructor(data?:any) {
		if (!data) return;
		this.ID = data.ID;
		this.Description = data.Description;
		this.Funcs = (data.Funcs || []).map((f:any)=>new FrontendFunc(f));
		this.Amount1 = data.Amount1;
		this.Amount2 = data.Amount2;
		this.ProductSku = data.ProductSku;
		this.ProductDescription = data.ProductDescription;
		this.UnitPrice = data.UnitPrice;
		this.LeeggoedTax = data.LeeggoedTax;
		this.EcoboniTax = data.EcoboniTax;
		this.AccijnzenTax = data.AccijnzenTax;
		this.VatID = data.VatID;
		this.ShouldRunScript = data.ShouldRunScript;
		this.VatRegimeFilter = [...(data.VatRegimeFilter || [])];
		this.SaleTypeFilter = [...(data.SaleTypeFilter || [])];
		this.SharedFuncList = (data.SharedFuncList || []).map((f:any)=>new SharedFuncReference(f));
	}

	getJSON(){
		return {
			ID: this.ID,
			Description: this.Description,
			Funcs: this.Funcs.map(f=>f.getJSON()),
			Amount1: this.Amount1,
			Amount2: this.Amount2,
			ProductSku: this.ProductSku,
			ProductDescription: this.ProductDescription,
			UnitPrice: this.UnitPrice,
			LeeggoedTax: this.LeeggoedTax,
			EcoboniTax: this.EcoboniTax,
			AccijnzenTax: this.AccijnzenTax,
			VatID: this.VatID,
			ShouldRunScript: this.ShouldRunScript,
			VatRegimeFilter: [...this.VatRegimeFilter],
			SaleTypeFilter: [...this.SaleTypeFilter],
			SharedFuncList: [...this.SharedFuncList.map(s=>s.getJSON())]
		};
	}
}